import React from "react";
import { MdCameraswitch } from "react-icons/md";

interface CameraToggleButtonProps {
  isVisible: boolean;
  facingMode: "user" | "environment";
  onToggle: () => void;
}

const CameraToggleButton: React.FC<CameraToggleButtonProps> = ({ isVisible, facingMode, onToggle }) => {
  if (!isVisible) return null;

  return (
    <button
      onClick={onToggle}
      className="absolute z-[60] flex items-center justify-center w-12 h-12 text-white transition-all duration-200 bg-black rounded-full top-4 right-4 bg-opacity-70 hover:bg-opacity-90 active:scale-95 shadow-lg border border-white border-opacity-20"
      aria-label={facingMode === "user" ? "Switch to back camera" : "Switch to front camera"}
    >
      <MdCameraswitch className="text-lg" />
    </button>
  );
};

export default CameraToggleButton;
